export const PROOF_ITEMS = [
  { id: "p1", ratio: "1 / 1", duration: "15s", label: "Product hook", img: "/reels/reel1.jpg", video: "/reels/reel1.mp4" },
  { id: "p3", ratio: "9 / 16", duration: "15s", label: "Kinetic type", img: "/reels/reel3.jpg", video: "/reels/reel3.mp4" },
  { id: "p8", ratio: "9 / 16", duration: "30s", label: "Product story", img: "/reels/reel8.jpg", video: "/reels/reel8.mp4" },
  { id: "p9", ratio: "9 / 16", duration: "15s", label: "Retail ad", img: "/reels/reel9.jpg", video: "/reels/reel9.mp4" },
  { id: "p2", ratio: "1 / 1", duration: "30s", label: "App promo", img: "/reels/reel2.jpg", video: "/reels/reel2.mp4" },
  { id: "p4", ratio: "9 / 16", duration: "30s", label: "Story ad", img: "/reels/reel4.jpg", video: "/reels/reel4.mp4" },
  { id: "p6", ratio: "16 / 9", duration: "15s", label: "Brand film", img: "/reels/reel6.jpg", video: "/reels/reel6.mp4" },
  { id: "p7", ratio: "9 / 16", duration: "15s", label: "Launch teaser", img: "/reels/reel7.jpg", video: "/reels/reel7.mp4" },
];

export const STEPS = [
  { n: "01", title: "Send the brief", desc: "Five quick details about your product, platform and brand vibe. Under two minutes." },
  { n: "02", title: "Free sample in 24 hours", desc: "We craft a custom scroll-stopping concept and drop it straight into your inbox." },
  { n: "03", title: "You decide", desc: "Love it, we finish it. If not, you walk away — zero cost, no strings." },
  { n: "04", title: "Delivered in days", desc: "Final high-res assets, cut for IG Reels, TikTok and YouTube Shorts." },
];

export const TIERS = [
  {
    name: "15s Motion Ad", price: "$250", badge: "",
    subtitle: "Fast product hooks & story ads",
    features: ["15-second animated ad", "One hook variation included", "Free 24h sample preview", "Licensed motion graphics & SFX", "3-day turnaround after approval"],
  },
  {
    name: "30s Motion Ad", price: "$350", badge: "Most popular",
    subtitle: "DTC story ads & SaaS product motion",
    features: ["30-second animated ad", "Two hook variations included", "Free 24h sample preview", "Custom typography & brand styling", "2-day turnaround after approval"],
  },
  {
    name: "60s+ / Campaign", price: "Custom", badge: "",
    subtitle: "Multi-angle ad packs & variations",
    features: ["Multi-cut campaign (60s+)", "Any ratio & format", "Free 24h sample preview", "Dedicated motion lead", "Priority fast-track delivery"],
  },
];

export const BENEFITS = [
  { title: "No filming days", desc: "Pure motion graphics, cutdowns and vector animation. No studios, no actors, no schedules." },
  { title: "No studio overhead", desc: "Every dollar saved on production goes straight back into your ad spend." },
  { title: "No retainer", desc: "Order per ad or scale up on demand whenever your calendar heats up." },
  { title: "Sample first", desc: "See exactly what you're paying for before a single dollar leaves your budget." },
];

export const FAQS = [
  { q: "What kind of videos do you create?", a: "Short-form motion graphics, kinetic typography and product-feature callouts for DTC brands, plus animated UI/product demos and explainer motion for B2B SaaS — tuned for Instagram Reels, TikTok, YouTube Shorts and paid social." },
  { q: "Do I need to film or ship product samples?", a: "No. We work from your existing product imagery, web assets and brand guidelines, combined with high-impact motion graphics. No filming, no shipping." },
  { q: "How does the free 24-hour sample work?", a: "Submit your brief with product details. Within 24 hours we send a custom sample preview. Love it and you pick a tier to finish it — if not, you owe nothing." },
  { q: "Why is Flownavy so affordable?", a: "We're in our portfolio-building phase for the first 50 DTC and B2B SaaS brands. Automated motion workflows and zero physical shoots let us deliver top-tier quality without agency bloat. Prices rise after the first 50." },
  { q: "What's the cost and speed?", a: "15s from $250, 30s from $350, campaigns custom. Your free sample arrives in 24 hours; approved projects land in 2–4 business days as 1080×1920 MP4 (or custom ratios)." },
  { q: "How do I get started?", a: "Fill out the brief form below — five quick details about your brand. It takes under two minutes and your free sample is on its way." },
];

export const PLATFORM_OPTS = ["Instagram Reels", "TikTok Ads", "YouTube Shorts", "Meta / Facebook", "All Platforms"];export const VIBE_OPTS = ["High energy / kinetic", "Minimalist & sleek", "Editorial / bold", "Humorous / punchy"];
export const LENGTH_OPTS = ["15-second ad ($250)", "30-second ad ($350)", "60s+ / custom campaign"];

export const SHOWCASE = [
  { id: "sc1", src: "/slides/s3.jpg", title: "12-HR Matte", tag: "Beauty" },
  { id: "sc2", src: "/slides/s2.jpg", title: "Ronin", tag: "Footwear" },
  { id: "sc3", src: "/slides/s1.jpg", title: "Kelvin", tag: "Beverage" },
];
